import { render } from "./index.vue?vue&type=template&id=9291f02a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9291f02a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\11710\\Desktop\\admin-box-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9291f02a"]])

export default __exports__